import { forwardRef } from 'react';
import { BaseMenuButton } from './__internal__/';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuButton = /*#__PURE__*/forwardRef(function MenuButton(props, ref) {
  return /*#__PURE__*/_jsx(BaseMenuButton, {
    ...props,
    ref: ref
  });
});
//# sourceMappingURL=MenuButton.js.map